<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2022-11-03 10:48:54
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2022-11-03 14:52:04
 * @FilePath: \seller.sviptrader.com\src\components\ui\tag\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div>
		<span :class="['tag', type]">{{ content }}</span>
	</div>
</template>
<script>
export default {
	props: {
		content: {
			type: String,
			default: '暂无',
		},
		type: {
			type: String,
			default: 'primary',
		},
	},
	data() {
		return {};
	},
};
</script>
<style lang="less" scoped>
.tag {
	height: 18px;
	line-height: 18px;
	padding: 1px 3px;
	border-radius: 2px;
	text-align: center;
	font-size: 12px;
}
.primary {
	color: @color-primary;
	background-color: fadeout(@color-primary, 90%);
}
.danger {
	color: @color-danger;
	background-color: fadeout(@color-danger, 90%);
}
.success {
	color: @color-success;
	background-color: fadeout(@color-success, 90%);
}
.warning {
	color: @color-warning;
	background-color: fadeout(@color-warning, 90%);
}
.info {
	color: @color-info;
	background-color: fadeout(@color-info, 90%);
}
</style>
